module.exports = __webpack_public_path__ + "media/images/plans/wedding_compact/hall-list/plan-wedding-lineup-tokai-1-5a1694a62de74bdb51d68630fdae035d.png";